/*
 * Copyright (c) Nexign, JSC, 2020.
 */
/**
 * Lazy loading of a component WizardCallsDetail
 *
 * @author Aleksandr Perkhunov
 */

import loadable from '../../utils/loadable';

export default loadable(() => import(/* webpackChunkName: "WizardCallsDetail" */ './components/WizardCallsDetail'), undefined);
